import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    fetchHeaderFooterComponent,
    showPopover,
} from './header-footer-actions';
import Icon from './icon';
import HeaderMobile from './header-mobile';
import { Helpers } from '../../../core/src/helpers';
import withWindowResize from '../../../ui/components/window-resize';
import { withError } from '../../../shared/components/error-boundary';
import HeaderDesktop from './header-desktop';
import UtilityNavContainer from '../../../utility/components/utility-nav-container';
import Link from '../../../shared/components/hyperlink';
// import HeaderDesktopClassic from './header-desktop-classic';
import Overlay from './overlay';

import './css/header.less';

const POPOVER_KEY = 'headerTabs';

const { memoize } = Helpers;

const getPrivateStoreHeader = memoize(
    (headerFooter, pStoreID) => {
        const { header } = headerFooter;
        const pStoreHeader = headerFooter[`header:${pStoreID}`];
        return pStoreHeader ? Object.assign(header, pStoreHeader) : header;
    },
    ({ header }, pStoreID) =>
        `${Object.keys(header)}-${pStoreID}-${header && header.nav && header.nav.length
        }`
);

function SkipLinks() {
    return (
        <ul className="skip-links" aria-label="Skip links">
            <li>
                <a
                    className="screenReading js-skip-link"
                    href="#content"
                    tabIndex={0}
                >
                    Skip to Content
                </a>
            </li>
            <li>
                <a
                    className="screenReading js-skip-link"
                    href="#footer"
                    tabIndex={0}
                >
                    Skip to Footer
                </a>
            </li>
        </ul>
    );
}

export class Header extends Component {
    static propTypes = {
        header: PropTypes.object.isRequired,
        fetchHeader: PropTypes.func.isRequired,
        device: PropTypes.string.isRequired,
        width: PropTypes.number,
        popover: PropTypes.bool.isRequired,
        showDropdown: PropTypes.func.isRequired,
    };

    static defaultProps = {
        width: 0
    }

    componentDidMount() {
        const { header, fetchHeader } = this.props;

        // TODO: need a better flag for if the data needs to be fetched
        if (!header.disabled && Object.keys(header.nav).length === 0) {
            fetchHeader();
        }
    }



    getHomeLink = () => {
        const {
            header,
            pStoreID
        } = this.props;
        if (!pStoreID || ['hpepp', 'epp'].find((x) => x === pStoreID.toLowerCase())) {
            return header.homeLogoLink || `${process.env.BASENAME}`;
        }
        return `${process.env.BASENAME}`;
    }


    render() {
        const {
            header,
            width,
            device,
            popover,
            isOverlay,
            showDropdown,
            isV2
        } = this.props;
        const { nav, disabled, version, customHTML, hideUtilityNAV } = header;
        const classic = version === 'v1';
        if (customHTML) {
            return <div dangerouslySetInnerHTML={Helpers.createMarkup(customHTML)} />
        }
        // TODO: TEMP
        if (disabled || header.nav.length === 0) {
            return null;
        }
        // TODO: z-index fix revisit when classic header is removed
        const zIndex = isOverlay ? 1024 : null;
        const logoLink = this.getHomeLink();

        return (
            <React.Fragment>
                {!hideUtilityNAV && <UtilityNavContainer isV2={isV2}/>}
                <div className={`header-container ${isV2 ? ' v2' : ''}`}>
                    <div className="nav-bar-container" style={{ zIndex }}>
                        <nav className="nav-bar" aria-label="Main">
                            <Link
                                to={logoLink}
                                aria-label="HP Logo"
                                makeBasenameRelative={logoLink === '/'}
                            >
                                <Icon icon="icon-hp-logo" />
                            </Link>
                            <SkipLinks />
                            {/* {classic ? (
                                <HeaderDesktopClassic nav={nav} />
                            ) :  */}
                            {width > 768 || device === 'desktop' ? (
                                <HeaderDesktop
                                    nav={nav}
                                    popover={popover}
                                    onHover={this.onHover}
                                    onClose={this.onDropDownClose}
                                    showDropdown={showDropdown}
                                />
                            ) : (
                                    <HeaderMobile nav={nav} />
                                )}
                        </nav>
                    </div>
                    <Overlay />
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const { userData, headerFooter, slugInfo } = state;
    const {
        profileData: {
            personData: { pStoreID },
        },
    } = userData;
    const { width, device } = state.ui;
    //TODO: temp code to isolate v2 header / footer css
    const isV2 = slugInfo.templateKey in { 'filters-v2': 1, 'sale-v4': 1, 'compare-v2': 1, 'dlp-v2': 1, 'pdp-v2': 1 }

    return {
        pStoreID,
        header: pStoreID
            ? getPrivateStoreHeader(headerFooter, pStoreID)
            : headerFooter.header,
        width,
        device,
        popover: headerFooter.popover === POPOVER_KEY,
        // TODO: revisit when classic header is removed
        isOverlay: headerFooter.popover !== null,
        overlayShade: headerFooter.overlayShade,
        isV2
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchHeader: () => dispatch(fetchHeaderFooterComponent(['header'])),
    showDropdown: (show) => dispatch(showPopover(show, true)),
});

export default withError(
    withWindowResize(connect(mapStateToProps, mapDispatchToProps)(Header))
);
